"use strict";
/// <reference path="irep.js"/>

IREP.itp = (function () {
    var options;

    var init = function (itpOptions) {
        options = itpOptions;

    };

    return {
        init: init
    };
})();